module.exports = __webpack_public_path__ + "img/icon_2_0.84808991.png";